import { render } from "./Fanzone.vue?vue&type=template&id=0824114c&ts=true"
import script from "./Fanzone.vue?vue&type=script&lang=ts"
export * from "./Fanzone.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__